export default function (item) {
  item.startTime = item.startTime.substring(0, 10)
  item.endTime = item.endTime.substring(0, 10)
  return item
}

/**
 * 提交的时候将startTime、endTime转换成字符串格式
 * @param {*} item
 */
export function submitTime (item) {
  // item.startTime = item.startTime + ' 00:00:00'
  // item.endTime = item.endTime + ' 00:00:00'
  item.startTime = GMTToStr(item.startTime)
  item.endTime = GMTToStr(item.startTime)
  return item
}

export let global = {
  singleFlag: true
}

/**
 * 转换成xxxx年xx月xx日的显示格式
 * @param {*} item
 */
export function changeTime (item) {
  let year = item.substr(0, 4)
  let mounth = item.substr(5, 2)
  let day = item.substr(8, 2)
  return year + '年' + mounth + '月' + day + '日'
  // return year + '年' + mounth + '月'
}

/**
 * 将Date格式的数据转换成字符串
 * @param {*} time
 */
export function GMTToStr (time) {
  let date = new Date(time)
  let Str = date.getFullYear() + '-' +
          (date.getMonth() + 1 + '').padStart(2, '0') + '-' +
          (date.getDate() + '').padStart(2, '0') + ' ' +
          (date.getHours() + '').padStart(2, '0') + ':' +
          (date.getMinutes() + '').padStart(2, '0') + ':' +
          (date.getSeconds() + '').padStart(2, '0')
  return Str
}

/**
 * 将字符串类型的日期转换成Date类型
 * @param {*} time
 */
export function StrToGMT (time) {
  let GMT = new Date(time)
  return GMT
}

export function compareTime (t1, t2) {
  return GMTToStr(t1) > GMTToStr(t2)
}



// WEBPACK FOOTER //
// ./src/common/js/userCenter/base.js